import { getCampaignPopupDetail, revokeCampaignPopup } from '../../../api/campaignPopupApi'
import RevokeCampaignPopupModal from '../../../components/campaign-popups/revoke-campaign-popup-template-modal/revoke-campaign-popup-modal'
import { keysToCamel } from '../../../helpers/keys-to-case'
import { getDateTime } from '../../../helpers/utils'
import AuthPermission from '../../../high-order-components/auth-permission'
import translate from '../../../i18n'
import { PermissionsEnum } from '../../../share-types'
import { CampaignPopupStatusOptions, CampaignPopupUserTypeOptions } from '../constant'
import { CampaignPopup as CampaignPopupType, CampaignPopupStatusEnums } from '../share-type'
import styles from './campaign-popup.module.less'
import { Button, Descriptions, Space, Tag, notification, Image } from 'antd'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { compose } from 'redux'

interface IProps {
  campaignPopupDetail: CampaignPopupType
}

const CampaignPopupDescriptions = ({ campaignPopupDetail }: IProps) => {
  const { summary, startDate, endDate, redirectUrl, redirectType, status, userType, imageUrl } =
    campaignPopupDetail

  return (
    <Descriptions
      bordered
      extra={status === CampaignPopupStatusEnums.INACTIVE && <Tag color="red">已失效</Tag>}
      column={1}
      styles={{ root: { width: '100%' }, label: { fontWeight: 600 } }}
    >
      <Descriptions.Item label={translate('campaignPopups.summary')}>{summary}</Descriptions.Item>
      <Descriptions.Item label={translate('campaignPopups.imageUrl')}>
        <Image width={200} src={imageUrl} />
      </Descriptions.Item>
      <Descriptions.Item label={translate('campaignPopups.startDate')}>
        {getDateTime(startDate)}
      </Descriptions.Item>
      <Descriptions.Item label={translate('campaignPopups.endDate')}>
        {getDateTime(endDate)}
      </Descriptions.Item>
      <Descriptions.Item label={translate('campaignPopups.redirectUrl')}>
        {redirectUrl}
      </Descriptions.Item>
      <Descriptions.Item label={translate('campaignPopups.redirectType')}>
        {redirectType}
      </Descriptions.Item>
      <Descriptions.Item label={translate('campaignPopups.userType')}>
        {CampaignPopupUserTypeOptions.find(item => item.value === userType)?.label}
      </Descriptions.Item>
      <Descriptions.Item label={translate('campaignPopups.status')}>
        {CampaignPopupStatusOptions.find(item => item.value === status)?.label}
      </Descriptions.Item>
    </Descriptions>
  )
}

const CampaignPopup = () => {
  const params = useParams()
  const navigate = useNavigate()
  const [campaignPopupId] = useState<string | undefined>(params?.id)
  const [visible, setVisible] = useState<boolean>(false)
  const [revokeCampaignPopupLoading, setRevokeCampaignPopupLoading] = useState<boolean>(false)
  const [campaignPopupDetail, setCampaignPopupDetail] = useState<CampaignPopupType>()

  useEffect(() => {
    if (campaignPopupId) {
      getCampaignPopupDetail(Number(campaignPopupId)).then((res: any) => {
        const campaignPopupDetail = keysToCamel(res)

        setCampaignPopupDetail(campaignPopupDetail)
      })
    }
  }, [campaignPopupId])

  const toEdit = () => {
    navigate(`/campaign-popups/${campaignPopupId}/edit`)
  }

  const goBack = () => {
    navigate('/campaign-popups')
  }
  const revokeCampaignPopupAction = () => {
    setVisible(true)
  }

  const handleOk = () => {
    if (campaignPopupId) {
      setRevokeCampaignPopupLoading(true)
      revokeCampaignPopup(Number(campaignPopupId))
        .then(() => {
          notification.success({
            title: translate('campaignPopups.revokeSuccess'),
          })
          setVisible(false)
          getCampaignPopupDetail(Number(campaignPopupId)).then((res: any) => {
            setCampaignPopupDetail(keysToCamel(res))
          })
        })
        .catch(error => {
          notification.error({
            title: translate('campaignPopups.revokeFailed'),
            description: error.message ?? '',
          })
        })
        .finally(() => {
          setRevokeCampaignPopupLoading(false)
        })
    }
  }

  const handleCancel = () => {
    setVisible(false)
  }

  return (
    <div className={styles['campaign-popup-desc-wrapper']}>
      {campaignPopupDetail && (
        <CampaignPopupDescriptions campaignPopupDetail={campaignPopupDetail} />
      )}
      <Space className={styles['button-group']}>
        <AuthPermission permission={PermissionsEnum.CAMPAIGN_POPUP_WRITE}>
          <Button
            type="primary"
            onClick={toEdit}
            disabled={
              campaignPopupDetail &&
              campaignPopupDetail.status === CampaignPopupStatusEnums.INACTIVE
            }
          >
            {translate('edit')}
          </Button>
        </AuthPermission>

        <Button onClick={goBack}>{translate('goBack')}</Button>

        <AuthPermission permission={PermissionsEnum.CAMPAIGN_POPUP_WRITE}>
          <Button
            disabled={
              campaignPopupDetail &&
              campaignPopupDetail.status === CampaignPopupStatusEnums.INACTIVE
            }
            type="primary"
            danger
            onClick={revokeCampaignPopupAction}
          >
            {translate('revoke')}
          </Button>
        </AuthPermission>
      </Space>
      <RevokeCampaignPopupModal
        visible={visible}
        handleOk={handleOk}
        handleCancel={handleCancel}
        loading={revokeCampaignPopupLoading}
      ></RevokeCampaignPopupModal>
    </div>
  )
}

export default compose()(CampaignPopup)
